import { GridViewSelect, GridViewsState } from '../types';

export const FeatureKey = 'gridViews';

export const GRID_VIEW_DROPDOWN_OPTIONS: GridViewSelect[] = [
  {
    id: 'Default',
    label: 'Default View',
  },
];

export const DEFAULT_GRID_VIEW_STATE: GridViewsState = {
  customFilters: {
    filters: {
      advancedFilters: {},
      searchString: ""
    },
    sortBy: {
      dir: "",
      field: ""
    }
  },
  customViews: {},
  defaultHeaders: undefined,
  gridType: undefined,
  selectedView: GRID_VIEW_DROPDOWN_OPTIONS[0]
};
